/**
 * DEV-1945 / DEV-1946. Разбор дубля в карточке клиента: баннер со ссылкой на
 * заявившего агента и двумя исходами — передать клиента ему или оставить как
 * есть. Плюс подпись видимой ссылки в уведомлении.
 */

const ruDuplicate = {
  title: 'Клиента уже приводил агент',
  lead: 'Агент прислал в панель клиента, который уже есть в базе. Решите, за кем он остаётся.',
  someAgent: 'Агент',
  unknownAgent:
    'Кто заявил дубль — не сохранилось. Передать клиента некому, вопрос можно только закрыть.',
  transfer: 'Передать этому агенту',
  keep: 'Оставить как есть',
  noPermission: 'Разобрать дубль может руководитель отдела продаж.',
  resolved: 'Дубль разобран — метка снята',
  matched: {
    phone: 'совпал телефон',
    email: 'совпал email',
  },
  confirm: {
    title: 'Передать клиента агенту?',
    description: 'Клиент перейдёт к агенту {agent}, а остальные заявки на дубль будут отклонены.',
    impact:
      'Канал привлечения станет «Агент», агентом карточки — {agent}. Метка «Дубль» снимется, и клиент пропадёт из виджета дублей.',
    impactDeals:
      'Канал привлечения станет «Агент», агентом карточки — {agent}. Привязка обновится у {n} активной сделки | Канал привлечения станет «Агент», агентом карточки — {agent}. Привязка обновится у {n} активных сделок | Канал привлечения станет «Агент», агентом карточки — {agent}. Привязка обновится у {n} активных сделок',
  },
}

const ruNotificationLink = {
  open: 'Открыть',
  openClient: 'Открыть карточку клиента',
}

const enDuplicate = {
  title: 'An agent has already brought this client in',
  lead: 'An agent submitted a client the company already had. Decide who keeps them.',
  someAgent: 'Agent',
  unknownAgent:
    'The claiming agent was not recorded. There is no one to transfer the client to — the case can only be closed.',
  transfer: 'Hand over to this agent',
  keep: 'Leave as is',
  noPermission: 'Only the head of sales can settle a duplicate.',
  resolved: 'Duplicate settled — the label is off',
  matched: {
    phone: 'phone matched',
    email: 'email matched',
  },
  confirm: {
    title: 'Hand the client over to the agent?',
    description: 'The client moves to {agent}, and the other duplicate claims are rejected.',
    impact:
      'The source channel becomes "Agent" and {agent} becomes the agent on the card. The "Duplicate" label comes off and the client leaves the duplicates widget.',
    impactDeals:
      'The source channel becomes "Agent" and {agent} becomes the agent on the card. {n} active deal is re-attached | {n} active deals are re-attached',
  },
}

const enNotificationLink = {
  open: 'Open',
  openClient: 'Open the client card',
}

const vnDuplicate = {
  title: 'Một đại lý đã từng đưa khách này vào',
  lead: 'Đại lý gửi lên một khách hàng đã có trong hệ thống. Hãy quyết định khách thuộc về ai.',
  someAgent: 'Đại lý',
  unknownAgent:
    'Không lưu được đại lý đã báo trùng. Không có ai để chuyển khách hàng — chỉ có thể đóng vấn đề.',
  transfer: 'Chuyển cho đại lý này',
  keep: 'Giữ nguyên',
  noPermission: 'Chỉ trưởng phòng kinh doanh mới xử lý được trùng lặp.',
  resolved: 'Đã xử lý trùng lặp — nhãn được gỡ',
  matched: {
    phone: 'trùng số điện thoại',
    email: 'trùng email',
  },
  confirm: {
    title: 'Chuyển khách cho đại lý?',
    description: 'Khách sẽ chuyển sang {agent}, các yêu cầu trùng lặp còn lại bị từ chối.',
    impact:
      'Kênh thu hút chuyển thành «Đại lý», đại lý của thẻ là {agent}. Nhãn «Trùng lặp» được gỡ và khách rời khỏi khối trùng lặp.',
    impactDeals:
      'Kênh thu hút chuyển thành «Đại lý», đại lý của thẻ là {agent}. Cập nhật {n} giao dịch đang mở.',
  },
}

const vnNotificationLink = {
  open: 'Mở',
  openClient: 'Mở thẻ khách hàng',
}

export const clientDuplicatesMessages = {
  ru: { clients: { duplicate: ruDuplicate }, notifications: { link: ruNotificationLink } },
  en: { clients: { duplicate: enDuplicate }, notifications: { link: enNotificationLink } },
  vn: { clients: { duplicate: vnDuplicate }, notifications: { link: vnNotificationLink } },
}
